import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { PartidaPresService } from '../../../services/formulacion/partida-pres.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-partida',
  templateUrl: './partida.component.html',
  styleUrls: [],
  providers: [PartidaPresService]
})
export class PartidaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourcePP: any[];
  model: any = {
    id: 0,
    codigo: '',
    descripcion: '',
    titulo: '',
    es_vigente: true
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;
  unidad_organizacional_id: number = 0;
  tipo_agregacion_id: number = 1;;
  constructor(private _ps: PartidaPresService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getPartidas();
    let u = JSON.parse(localStorage.getItem('u'));        
    this.tipo_agregacion_id = 1;  
    this.unidad_organizacional_id = u.unidad; 
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, descripcion: false, titulo: false };
  }

  getPartidas() {
    this._ps.getPartidaPres().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourcePP = result.data;
        } else {
          this.dataResourcePP = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.descripcion = '';
    this.model.titulo = '';
    this.model.es_vigente = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.descripcion = data.descripcion;
    this.model.titulo = data.titulo;
    this.model.es_vigente = data.es_vigente;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  savePartida() {
    this.hasError = { codigo: false, descripcion: false, titulo: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._ps.postPartidaPres(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPartidas();
              this.popupVisibleAdd = false;              
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data);   
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._ps.putPartidaPres(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPartidas();
              this.popupVisibleAdd = false;              
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data);   
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deletePartida() {
    this._ps.deletePartidaPres(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPartidas();
          this.popupVisibleDel = false;          
          toastr.success('Proceso realizado correctamente.');          
        } else {              
          toastr.warning(result.data);   
        }
      },
      (error) => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    if (!UtilHelper.validator(data.titulo, 'text')) {
      this.hasError.titulo = true; res = false;
    }
    return res;
  }
}
